import React, { useEffect, useRef, useState } from 'react';
import Icon from './Icon';
import ScreenBlocks from './ScreenBlocks';
import { WORKFLOWS, TONES } from './homeData';

const WINDOW_RAIL = ['home', 'shopping-cart', 'line-chart', 'package', 'factory', 'landmark'];

const WorkflowShowcase = () => {
  const [wf, setWf] = useState(0);
  const [step, setStep] = useState(0);
  const [paused, setPaused] = useState(false);
  const timer = useRef(null);

  const active = WORKFLOWS[wf];
  const stepCount = active.steps.length;

  // Auto-advance through the active workflow's steps.
  useEffect(() => {
    if (paused) return undefined;
    timer.current = setInterval(() => {
      setStep((s) => (s + 1) % stepCount);
    }, 5000);
    return () => clearInterval(timer.current);
  }, [paused, stepCount, wf]);

  const selectWorkflow = (i) => { setWf(i); setStep(0); };

  const screen = active.steps[step].screen;
  const badgeTone = TONES[screen.badge[1]];
  const counter = '0' + (step + 1) + ' / 0' + stepCount;

  return (
    <section id="workflows" className="rl-section rl-section--alt">
      <div className="rl-container rl-reveal">
        <div className="rl-head rl-head--center">
          <div className="rl-eyebrow">— End to end</div>
          <h2 className="rl-h2">Three cycles run your business. <em>Walk through each one.</em></h2>
          <p className="rl-lead rl-lead--center">Every step below is a real screen, and the data carries forward on its own — no re-entry between departments.</p>
        </div>

        <div className="wf-toolbar">
          <div className="wf-tabs">
            {WORKFLOWS.map((w, i) => (
              <button
                type="button"
                key={w.name}
                className={`wf-tab ${i === wf ? 'is-active' : ''}`}
                style={i === wf ? { borderColor: w.color, background: w.tint, color: w.color } : undefined}
                onClick={() => selectWorkflow(i)}
              >
                <Icon name={w.icon} size={16} />{w.name}
              </button>
            ))}
          </div>
          <button type="button" className="wf-playtoggle" onClick={() => setPaused((p) => !p)}>
            <span className="wf-playdot" style={{ background: paused ? 'var(--raya-slate-400)' : 'var(--raya-mint-500)' }} />
            {paused ? 'Paused' : 'Auto-playing'}
          </button>
        </div>

        <div
          className="wf-body"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          {/* Stepper */}
          <div className="wf-stepper">
            <div className="wf-stepper-head">
              <div className="wf-stepper-icon" style={{ background: active.tint, color: active.color }}>
                <Icon name={active.icon} size={19} />
              </div>
              <div>
                <h3 className="wf-stepper-name">{active.name}</h3>
                <div className="wf-stepper-sub">{active.sub}</div>
              </div>
            </div>
            <div className="wf-stepper-tag">{active.tag}</div>
            <div className="wf-steps">
              {active.steps.map((s, i) => {
                const done = i <= step;
                const isActive = i === step;
                return (
                  <button
                    type="button"
                    key={s.label}
                    className={`wf-step ${isActive ? 'is-active' : ''}`}
                    style={isActive ? { background: 'var(--raya-slate-50)', borderColor: active.color } : undefined}
                    onClick={() => setStep(i)}
                  >
                    <span
                      className="wf-step-num"
                      style={{ background: done ? active.tint : 'var(--raya-slate-100)', color: done ? active.color : 'var(--raya-slate-500)' }}
                    >
                      <Icon name={s.icon} size={13} />
                    </span>
                    <span className="wf-step-text">
                      <span className="wf-step-label" style={{ color: isActive ? 'var(--raya-slate-900)' : 'var(--raya-slate-600)' }}>{s.label}</span>
                      <span className="wf-step-sub">{s.sub}</span>
                    </span>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Live window */}
          <div className="rl-window-frame">
            <div className="rl-window rl-window--rail">
              <div className="rl-window-rail">
                {WINDOW_RAIL.map((icon, i) => (
                  <div
                    key={icon}
                    className="rl-rail-item"
                    style={{
                      color: i === active.rail ? '#93c5fd' : 'rgba(255,255,255,0.55)',
                      background: i === active.rail ? 'rgba(96,165,250,0.18)' : 'transparent',
                    }}
                  >
                    <Icon name={icon} size={15} />
                  </div>
                ))}
              </div>
              <div>
                <div className="rl-window-bar">
                  <span className="rl-window-crumb">{screen.crumb}</span>
                  <span className="rl-window-baraside">
                    <span className="rl-badge" style={{ color: badgeTone[0], background: badgeTone[1] }}>{screen.badge[0]}</span>
                    <span className="rl-window-counter">{counter}</span>
                  </span>
                </div>
                <div className="wf-screen">
                  <div className="wf-screen-title">{screen.title}</div>
                  <ScreenBlocks blocks={screen.blocks} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkflowShowcase;
